<template>
  <section class="header_div">
    <div class="header_slim_con">
      <div class="header_con">
        <ul class="left_menu">
          <li class="menu" @click="add_interest()">즐겨찾기</li>
          <li class="menu" @click="$router.push('/popcon_partner_apply')">입점신청</li>     
          <!-- <li class="menu" @click="$router.push('/popcon_introduction')">팝콘 소개</li>           -->
        </ul>
        <ul class="right_menu">
          <li class="menu" v-if="is_login" ><span style="font-weight:bold">{{ nickname }}</span>님 환영합니다!</li>
          
          <li class="menu" v-if="!is_login" @click="$router.push('/login')">로그인</li>
          <li class="menu" v-if="is_login" @click="logout()">로그아웃</li>
          <li class="menu" v-if="is_login" @click="$router.push('/mypage/account')">회원정보</li>
          
          <li class="menu" v-if="!is_login" @click="$router.push('/signup')">회원가입</li>
          <li class="menu">고객센터
            <ul class="sub_right_menu">
              <li class="sub_right_menu_item" @click="$router.push('/notice')" >공지사항</li>
              <li class="sub_right_menu_item"  @click="$router.push('/faq')">자주 묻는 질문</li>
              <li class="sub_right_menu_item"  @click="$router.push('/contact_us')">문의하기</li>
            </ul>  
          </li>                    
        </ul>
      </div>
    </div>
    <div style="width:100% ;  height:80px; ">
      <div class="container" style="position:relative">
        <img
          class="main_logo cp"
          @click="$router.push('/')"
          src="/static/images/logo_big.jpg"
          alt="로고"
        >
        <input class="searchbar" v-model="q" v-on:keyup.enter="search()" type="text" placeholder="#태그 또는 검색어를 입력해주세요.">
        <div class="search_btn"><i class="fas fa-search 3x"></i></div>
        <ul class="menu_ul">
          <li class="cp" @click="go_mypage()" style="text-align:center;"> <i class="far fa-user " style="font-size:20px;"></i><br> <span style="font-size:12px;">마이 팝콘</span> <div v-if="my_page_event" class="badge">{{ my_page_event }}</div></li>
          <li class="cp" @click="$router.push('/matching')" style="text-align:center;" ><i class="fab fa-elementor" style="font-size:20px;"></i><br><span style="font-size:12px;"> 파트너스 </span> <div v-if="partners_event" class="badge">{{partners_event}}</div> </li>
          <li class="cp" @click="$router.push('/bidding')" style="text-align:center;" ><i class="fas fa-boxes" style="font-size:20px;"></i><br><span style="font-size:12px;"> 프로젝트 </span> <div v-if="projects_event"  class="badge">{{projects_event}}</div>  </li>  
        </ul>
      </div>
    </div>
    <div style="width: 100%; padding-top:5px; border-bottom:1px solid #ddd;">
      <div class="container">
        <ul class="sub_menu" style="padding-left: 0px;">
          <li :class="{'sub_menu_item':true , 'is_active':is_active(menu.url)  }" v-for="menu in menu_item" :key="menu.url+menu.index"  class="sub_menu_item" :data-isExternal="menu.is_external" @click="page_move($event,menu.url)">{{menu.name}}</li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
import EventBus from "@/EventBus.js";
import Bidding from "@/SPA/Components/Bidding/Bidding.vue"
export default {
  components: { Bidding },
  data() {
    return { 
      is_login: false, 
      register_modal_open: false ,
      write_bidding: false,
      menu_item : [],
      q:"",
      nickname:"",
      my_page_event:0,
      partners_event:0, 
      projects_event:0
      };      
  },
  methods: {
    is_active(url){
      let current_url = this.$route.fullPath
      console.log(current_url)
      if(this.$route.path !="/"){
        if(url.indexOf( current_url ) != -1){ 
            return true
          } 
          else { 
            return false
          }
      }
      
    },
    go_mypage(){
      if( localStorage.getItem("login") == "true"  ){
        if(  localStorage.getItem("kind") == "user" )
        this.$router.push('/mypage/content')
        else{
          this.$router.push('/partner_mypage/partner_report')
        }
      }else{
        alert("로그인 이후 이용해주세요.")
      }
    },
    page_move(event,url){
      if ( $(event.target).attr("data-isExternal") != "false" ){
        this.$router.push(url)
      }else{
        location.href=url;
      }
    },
    logout() {
      localStorage.removeItem("id");
      localStorage.removeItem("session_key"); 
      localStorage.removeItem("login");
      alert("로그아웃 되었습니다");
      location.href = "/";
    },
    add_interest(){
      alert('Ctrl+D 키를 누르면 즐겨찾기에 추가하실 수 있습니다.');
    },
    search(){
      this.$router.push("/search?q="+this.q)
    }
  },
  mounted() {
    this.q = this.$route.query.q
    if(this.$route.fullPath == "/popcon_contents?content=popsign"){
      console.log("here")
      $(".sub_menu_item").removeClass("is_active")
      $(".sub_menu_item:eq(2)").addClass("is_active")
    }
    else if(this.$route.fullPath == "/popcon_contents?content=textile" ){

    }
    if (localStorage.getItem("login") == "true") {
      this.is_login = true;
    }
    EventBus.$on("logout", () => {
      this.is_login = false;
      this.logout();
    });
    EventBus.$on("login", () => {
      this.is_login = true;
    });
    EventBus.$on("push_event_check",()=>{
      this.$http.get(`/app/get_push_event_check`).then(res=>{
           this.my_page_event = res.data.project_event +  res.data.community_event + res.data.inquiry_event + res.data.event_event 
        })
    })
    this.$http.get("app/get_menu_item").then(res=>{
      this.menu_item = res.data.result
    })
    this.$http.get("app/get_user_name").then((res=>{
      this.nickname = res.data.nickname
    }))
    this.$http.get(`/app/get_push_event_check`).then(res=>{
       this.my_page_event = res.data.project_event +  res.data.community_event + res.data.inquiry_event   + res.data.event_event 
    })
    let url = ""
    if(window.location.href.indexOf("localhost") === -1 ){
      //  프로덕션
       url = "popcontents.com:8001/api"
    }
    else{
      // 개발
       url = "localhost:8001/api"
    } 

    let signalSocket = new WebSocket(
        'ws://' + url +
        '/ws/signal/');

    signalSocket.onmessage = (e)=> {      
        let data = JSON.parse(e.data);
        let message = data['message'];       
        // 데이터를 받으면 서버에서 상태를 체크할것 
        this.$http.get(`/app/get_push_event_check`).then(res=>{
          console.log(res)
         this.my_page_event = res.data.project_event +  res.data.community_event + res.data.inquiry_event  + res.data.event_event  
        })
    };
    signalSocket.onopen=function (e) {
      console.log("연결 성공");
    };


  }
};
</script>

<style scoped lang="scss">
.menu_ul{
  .badge{
    background-color: blueviolet;
    position: absolute;
    top: -9px;
    right: 5px;
  }
 
}
.header_slim_con{
  width: 100%;
  height: 32px;
  background: #F0F0F0;
  z-index: 3;
  .header_con{
    width: 1120px;
    margin:0px auto;    
    text-align: justify;
    .left_menu{
      margin-bottom: 0px;
      float: left;
      li{
        margin-right: 20px;
      }
    }
    .right_menu{
      float:right;
      position: relative;
      li.menu{
        margin-left: 20px;
        .sub_right_menu{
          position: absolute;
          width: 120px;
          z-index: 10;
          background-color: #fff;
          border:1px solid #ddd;          
          line-height: 35px;
          display: none;
          li{
            padding-left: 10px;
            width:100%;
            border-bottom:1px solid #ddd;
          }
          li:hover{
            color: red;
          }
        }
        .sub_right_menu:hover{
           display: block;
        }
      }
      li:hover > .sub_right_menu{
        display: block;         
      }
    }
    ul{
      margin-block-start:0px;
      margin-block-end: 0px;
      list-style: none;
      padding-left: 0px;
      li{
        cursor: pointer;
        float:left;
        font-size: 11px;
        line-height: 32px;
      }
    }
  }
}
.searchbar{
  width: 518px;
  height: 41px; 
  border:2px solid #cb3e3e;
  margin-top: 20px;
  padding-left: 20px;
  outline: none;
  margin-left: 50px;
  color:#666;
  float:left;
}
.search_btn{
  position: absolute;
  top: 24px;
  left: 500px;
  background-color: #fff;
  color:#cb3e3e;;
  width: 35px;
  height: 35px;
  font-size:21px;
  line-height: 31px;
  text-align: center;
  border-radius: 40px;
  left:50%;
  margin-left:178px;
  cursor: pointer;
}
.cp {
  cursor: pointer;
  position: relative;
}
.main_logo {
  float: left;
  margin: 10px;
  height: 40px;
  margin-top:16px;
}
.menu_ul {
  position:absolute;
  top: 23px;
  right: 0px;
  margin: 10px;
  margin-top:0px;
  list-style: none;
  li {
    display: inline-block;
    margin-right: 30px;
    font-size: 15px;
  }
  li:last-child {
    margin-right: 0px !important;
  }
}
.sub_menu{
  height: 29px;
  margin-left: 10px;
  margin-bottom: 0px;
  .sub_menu_item{
    font-size: 14px;
    font-weight: bold;
    float:left;
    margin-right: 40px;
    color:#343a40;
    height:30px;
    cursor: pointer;    
    
  }
  .sub_menu_item:hover{
    border-bottom:  2px solid #cb3e3e ;
    color: #cb3e3e;
  }
  .is_active{
    border-bottom:  2px solid #cb3e3e ;
    color: #cb3e3e;
  }

  .sub_menu_item:hover{
    color: red;
  }
  .sub_menu_item:last-child::after{
    content: "";
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/SharedComponents/Header.vue